import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconAdd, IconRemove } from '@travel-frontend/icons';
import { IconButton } from '../../primitives/IconButton/index.js';
import { Container } from '../../primitives/Stepper/components/Container.js';
import { Value } from '../../primitives/Stepper/components/Value.js';
export const Stepper = /*#__PURE__*/_styled(({
  value,
  min = 0,
  max = Infinity,
  onChange,
  disableDecrement,
  disableIncrement,
  ...restProps
}) => {
  const decrement = () => value > min && onChange(value - 1);
  const increment = () => value < max && onChange(value + 1);
  return _jsxs(Container, {
    ...restProps,
    children: [_jsx(IconButton, {
      onClick: decrement,
      category: "secondary",
      round: true,
      disabled: disableDecrement === undefined ? value <= min : disableDecrement,
      "data-testid": "decrement",
      children: _jsx(IconRemove, {})
    }), _jsx(Value, {
      "data-label": value,
      active: value > 0,
      children: value
    }), _jsx(IconButton, {
      onClick: increment,
      category: "secondary",
      round: true,
      disabled: disableIncrement === undefined ? value >= max : disableIncrement,
      "data-testid": "increment",
      children: _jsx(IconAdd, {})
    })]
  });
}, process.env.NODE_ENV === "production" ? {
  target: "ew3l9s10"
} : {
  target: "ew3l9s10",
  label: "Stepper"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN0ZXBwZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBVUciLCJmaWxlIjoiU3RlcHBlci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4LCBqc3hzIGFzIF9qc3hzIH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBJY29uQWRkLCBJY29uUmVtb3ZlIH0gZnJvbSAnQHRyYXZlbC1mcm9udGVuZC9pY29ucyc7XG5pbXBvcnQgeyBJY29uQnV0dG9uIH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9JY29uQnV0dG9uL2luZGV4LmpzJztcbmltcG9ydCB7IENvbnRhaW5lciB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvU3RlcHBlci9jb21wb25lbnRzL0NvbnRhaW5lci5qcyc7XG5pbXBvcnQgeyBWYWx1ZSB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvU3RlcHBlci9jb21wb25lbnRzL1ZhbHVlLmpzJztcbmV4cG9ydCBjb25zdCBTdGVwcGVyID0gc3R5bGVkKCh7IHZhbHVlLCBtaW4gPSAwLCBtYXggPSBJbmZpbml0eSwgb25DaGFuZ2UsIGRpc2FibGVEZWNyZW1lbnQsIGRpc2FibGVJbmNyZW1lbnQsIC4uLnJlc3RQcm9wcyB9KSA9PiB7XG4gICAgY29uc3QgZGVjcmVtZW50ID0gKCkgPT4gdmFsdWUgPiBtaW4gJiYgb25DaGFuZ2UodmFsdWUgLSAxKTtcbiAgICBjb25zdCBpbmNyZW1lbnQgPSAoKSA9PiB2YWx1ZSA8IG1heCAmJiBvbkNoYW5nZSh2YWx1ZSArIDEpO1xuICAgIHJldHVybiAoX2pzeHMoQ29udGFpbmVyLCB7IC4uLnJlc3RQcm9wcywgY2hpbGRyZW46IFtfanN4KEljb25CdXR0b24sIHsgb25DbGljazogZGVjcmVtZW50LCBjYXRlZ29yeTogXCJzZWNvbmRhcnlcIiwgcm91bmQ6IHRydWUsIGRpc2FibGVkOiBkaXNhYmxlRGVjcmVtZW50ID09PSB1bmRlZmluZWQgPyB2YWx1ZSA8PSBtaW4gOiBkaXNhYmxlRGVjcmVtZW50LCBcImRhdGEtdGVzdGlkXCI6IFwiZGVjcmVtZW50XCIsIGNoaWxkcmVuOiBfanN4KEljb25SZW1vdmUsIHt9KSB9KSwgX2pzeChWYWx1ZSwgeyBcImRhdGEtbGFiZWxcIjogdmFsdWUsIGFjdGl2ZTogdmFsdWUgPiAwLCBjaGlsZHJlbjogdmFsdWUgfSksIF9qc3goSWNvbkJ1dHRvbiwgeyBvbkNsaWNrOiBpbmNyZW1lbnQsIGNhdGVnb3J5OiBcInNlY29uZGFyeVwiLCByb3VuZDogdHJ1ZSwgZGlzYWJsZWQ6IGRpc2FibGVJbmNyZW1lbnQgPT09IHVuZGVmaW5lZCA/IHZhbHVlID49IG1heCA6IGRpc2FibGVJbmNyZW1lbnQsIFwiZGF0YS10ZXN0aWRcIjogXCJpbmNyZW1lbnRcIiwgY2hpbGRyZW46IF9qc3goSWNvbkFkZCwge30pIH0pXSB9KSk7XG59KSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVN0ZXBwZXIuanMubWFwIl19 */");